import { styled } from '@mui/material/styles';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

// *************** accordion styles *******************
const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  borderRadius: ' 0 0 16px 16px',
  width: '100%',
  borderTop: '1px solid #FFFFFF',
  '&:not(:last-child)': {},
  '&:before': {
    display: 'none'
  }
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({}));

export const Dropdown = (props) => {
  const { children, openByDefault = false } = props;
  const [expanded, setExpanded] = useState(openByDefault);

  const toggleAcordion = () => {
    setExpanded(!expanded);
  };

  return (
    <Accordion
      sx={{
        background: ' rgba(255, 255, 255, 0.5)',
        mt: 'auto'
      }}
      expanded={expanded}
    >
      <div
        onClick={toggleAcordion}
        aria-controls="dropdown-content"
        id="dropdown-header"
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: ' 0 5px 15px',
          fontSize: '12px',
          height: '32px'
        }}
      >
        <div
          style={{
            position: 'absolute',
            bottom: '0',
            color: 'rgba(117, 60, 190, 1)'
          }}
        >
          {expanded ? (
            <ExpandLessIcon
              sx={{
                fontSize: '1.3rem',
                color: '#A0A0A0'
              }}
            />
          ) : (
            <ExpandMoreIcon
              sx={{
                fontSize: '1.3rem',
                color: '#A0A0A0'
              }}
            />
          )}
        </div>
      </div>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};
